
<app-pageheader [Parent]="this">
  <add-button AddRoute="/integrations/reliant/new/edit"></add-button>
</app-pageheader>

<app-datalistview [Columns]="Columns" [ShowMap]="false" ApiUrl="integrations/reliant/configuration/search"
  [AllowEdit]="true" EditUrl="/integrations/reliant/:id">
  <app-filter-set>
    <div app-search-filter></div>
    <div app-search-button></div>
  </app-filter-set>
</app-datalistview> 